import { format, parse } from "date-fns";
import { calculateProjectTotalFinancialsNew } from "../../project-details/project-health/project-financials/single-project/single-project-totals.util";

const parseDateCreated = (dateString) => {
  const input = dateString; // DD/MM/YYYY
  const parsedDate = parse(input, "d/M/yyyy", new Date());
  if (isNaN(parsedDate)) {
    return null; // Handle invalid date
  }
  const output = format(parsedDate, "MM/dd/yyyy");

  return output;
};

const parseStartDateCreated = (dateString) => {
  const input = dateString; // DD/MM/YYYY
  const parsedDate = parse(input, "yyyy-MM-dd", new Date());
  if (isNaN(parsedDate)) {
    return null; // Handle invalid date
  }
  const output = format(parsedDate, "MM/dd/yyyy");

  return output;
};
export const parsedProjectsFilterData = (
  searchFilteredProjects,
  users,
  rateCards,
  companiesList
) => {
  return searchFilteredProjects?.map((project) => ({
    ...project,
    tableRowId: project.id,

    dateCreated: project.dateCreated
      ? parseDateCreated(project.dateCreated)
      : null,
    start: project.start ? parseStartDateCreated(project.start) : null,

    financials: calculateProjectTotalFinancialsNew(
      project,
      users,
      rateCards,
      companiesList
    ),
  }));
};
